import {useHistory} from '@aboutyou/router';

export const useRenderAsTwa = () => {
  const queryParams = new URLSearchParams(useHistory().location.search);

  return queryParams.get('isTwa') === 'true';
};
